import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q33jfvrznn: FaireBrandEntity = {
  token: "b_q33jfvrznn",
  type: "brand",
  name: "Sewn and Seen",
  avatarUrl:
    "https://cdn.faire.com/fastly/30432caa8bbcd8e9958ec4ff5dbe0c4bb911188a70eec46d19ca64266153ba77.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a31c2674780df324ecf8f92fcb64b8452c8bc34566bd670ec4a86e6446275ef5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/30432caa8bbcd8e9958ec4ff5dbe0c4bb911188a70eec46d19ca64266153ba77.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a31c2674780df324ecf8f92fcb64b8452c8bc34566bd670ec4a86e6446275ef5.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 117,
  isTopShop: true,
  isInsider: true,
  description:
    "At Sewn and Seen, we believe your clothes should feel as effortless and authentic as your everyday life. Our collections are designed to celebrate comfort without sacrificing style—from relaxed, loose-fit silhouettes to easygoing boho details and a touch of western spirit.\n\nInspired by the energy of game day gatherings, the joy of 4th of July celebrations, and the laid-back vibe of weekends well spent, our pieces bring versatility to your boutique. Each garment is thoughtfully crafted with quality materials and our signature mineral-washed finishes, creating that perfectly lived-in feel from the very first wear.\n\nWhether your customers are dressing up for a casual night out, cheering for their team, or simply embracing everyday moments, Sewn and Seen offers timeless styles they’ll reach for again and again. When you choose our line, you’re choosing comfort, character, and pieces that are always seen—and never forgotten.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:19.734Z",
    importedBy: "entity-db-cli",
  },
};
